import Headroom from 'headroom.js'
import MicroModal from 'micromodal'
// import 'slick-carousel'

// const initEvents = () => {
//   $('.event-slider').slick({
//     arrows: true,
//     appendArrows: $('.e-arrows'),
//     prevArrow: '<button type="button" class="slick-prev"><i class="fal fa-chevron-circle-left"></i></button>',
//     nextArrow: '<button type="button" class="slick-next"><i class="fal fa-chevron-circle-right"></i></button>',
//     dots: false,
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1100,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 700,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           centerMode: true,
//         },
//       },
//     ],
//   })
// }

const initHeader = () => {
  //Headroom Functionality
  let headroom = new Headroom(document.querySelector('header'), {
      tolerance: 10,
    })
  headroom.init()
  $(document).on('click', '[data-toggle-nav]', () => {
    $('.mobile').toggleClass('nav-active')
    $('.wrap').toggleClass('no-scroll')
  })
}

/**
 * Functionality for the Benefits Block modals.
 */
const modals = () => {
  MicroModal.init({
    awaitCloseAnimation: true,
  })
  // $('[data-micromodal-trigger="modal-1"]').trigger('click')
  // console.log('TRIGGERED!')
}

const popup = () => {
  setTimeout(() => {
    MicroModal.show('popup')
    // $('[data-micromodal-trigger="popup"]').trigger('load')
    console.log('TRIGGERED!')
  }, 5000)
}


export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // initEvents()
    initHeader()
    modals()
    popup()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js